import './index_mWeb.css';
import useTheme from '../../../utilities/hooks/theme';
import { View, Text } from '../../../component';
import React from 'react';

type TeamPreviewHeaderProps = {
  username: string;
  teamNumber: number;
  completed: boolean;
  userTeamScore: number;
  teamA: any;
  teamB: any;
};

const TeamPreviewHeaderMWeb = ({
  username,
  teamNumber = 1,
  completed = false,
  userTeamScore,
  teamA = {},
  teamB = {}
}: TeamPreviewHeaderProps) => {
  const { FantasyTheme: theme } = useTheme();
  const teamNumberColor = {
    color: theme.teamPreviewTeamNumber
  };

  const scoreColor = {
    color: theme.teamPreviewScore
  };

  const userName = username.match(/^[0-9a-fA-F]{24}$/) ? '' : `${username}`;

  return (
    <View className="team-preview-header-container_mWeb">
      <Text className="team-preview-team-number_mWeb" style={teamNumberColor}>
        {userName ? ` ${username} (T${teamNumber})` : `Team No. ${teamNumber}`}
      </Text>
      {completed && (
        <Text
          className="team-preview-score_mWeb"
          style={scoreColor}>{`Total Points : ${userTeamScore}`}</Text>
      )}
      <View className="team-preview-team-a-container_mWeb">
        <View className="team-preview-team-a-indicator_mWeb" />
        <Text
          className="team-preview-team-title_mWeb"
          style={teamNumberColor}>{`${teamA?.shortName}`}</Text>
      </View>
      <View className="team-preview-team-a-container_mWeb">
        <View className="team-preview-team-b-indicator_mWeb" />
        <Text
          className="team-preview-team-title_mWeb"
          style={teamNumberColor}>{`${teamB?.shortName}`}</Text>
      </View>
    </View>
  );
};
export default React.memo(TeamPreviewHeaderMWeb);
